import axios from 'axios'
import store from '@/store'
export default {
  isRefreshed: false,
  async refresh () {
    if (!this.isRefreshed) {
      this.isRefreshed = true
      return axios.post('/api/auth/refresh', {
        user_id: store.getters.getUser.id,
        refresh_token: localStorage.getItem('refresh_token')
      }).then((response) => {
        localStorage.setItem('refresh_token', response.data.refresh_token)
        store.dispatch('setAccessToken', response.data.access_token)
        response.isRefreshed = true
        return response
      }).finally(() => {
        this.isRefreshed = false
        window.location.reload()
      })
    }
    return new Promise((resolve, reject) => {
      resolve()
    })
  }
}
